import { Routes, Route } from 'react-router-dom';
import PortalLayout from '../shared/components/PortalLayout';
import { useAuth, userIsAdmin, userIsSupervisor } from '../context/AuthContext';

// V3 Nómina pages
import NominaHomePage from './pages/NominaHomePage';
import ProjectSheetsPage from './pages/ProjectSheetsPage';
import TarjetaPage from './pages/TarjetaPage';
import TarjetaDetailPage from './pages/TarjetaDetailPage';

// V4 Admin pages
import GangasPage from './pages/GangasPage';

// Legacy weekly timesheet pages
import MyTimesheetPage from './pages/MyTimesheetPage';
import TimesheetHistoryPage from './pages/TimesheetHistoryPage';
import TimesheetDetailPage from './pages/TimesheetDetailPage';
import TimesheetReviewPage from './pages/TimesheetReviewPage';
import TimesheetReportsPage from './pages/TimesheetReportsPage';

export default function TimesheetPortal() {
  const { user } = useAuth();
  const isAdm = userIsAdmin(user);
  const isSup = userIsSupervisor(user);

  return (
    <PortalLayout activeModule="horas">
      <Routes>
        {/* V3 Nómina routes (default) */}
        <Route index element={<NominaHomePage />} />
        <Route path="proyecto/:projectId" element={<ProjectSheetsPage />} />
        <Route path="tarjeta/:sheetId" element={<TarjetaPage />} />
        <Route path="detalle/:id" element={<TarjetaDetailPage />} />

        {/* V4 Admin routes */}
        {isAdm && <Route path="proyecto/:projectId/gangas" element={<GangasPage />} />}

        {/* Legacy weekly timesheet routes */}
        <Route path="semanal" element={<MyTimesheetPage />} />
        <Route path="historial" element={<TimesheetHistoryPage />} />
        <Route path="legacy/:id" element={<TimesheetDetailPage />} />
        {isSup && <Route path="revision" element={<TimesheetReviewPage />} />}
        {isAdm && <Route path="reportes" element={<TimesheetReportsPage />} />}
      </Routes>
    </PortalLayout>
  );
}
